"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./ReassignDivider.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ReassignDivider = function ReassignDivider(_ref) {
  var userAgent = _ref.userAgent;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-reassign-divider"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-reassign-divider-line"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-reassign-divider-span"
  }, userAgent));
};
var _default = exports["default"] = ReassignDivider;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/common/ReassignDivider/ReassignDivider.js
// module id = 1435
// module chunks = 0